import type { flotte as Fr } from '../fr/flotte';

/** « flotte » in English — typed on the French: a missing sentence does not compile. */
export const flotte: typeof Fr = {
  typeDoc: {
    assurance: 'Insurance', controle_technique: 'Technical inspection', vignette: 'Road tax', carte_grise: 'Registration',
  },
  archivee: 'Vehicle archived — it leaves the planning board and the lists.',
  archivageEchec: 'Archiving failed.',
  enService: (v: string) => `${v} is back in service.`,
  remiseEchec: 'Putting it back in service failed.',
  manque: {
    immatriculation: 'the registration', marque: 'the make', modele: 'the model',
    haute: 'the summer rate', basse: 'the winter rate',
  },
  ilManque: (n: number, liste: string) => `${n > 1 ? 'Still missing' : 'Missing'}: ${liste}.`,
  erreur: 'Error',
  depassee: (t: string) => `${t} · overdue`,
  resteKm: (t: string, km: string, u: string) => `${t} · ${km} ${u}`,
  resteJours: (t: string, j: number) => `${t} · D-${j}`,
  docJours: (t: string, j: number) => `${t} · D-${j}`,
  titre: 'My vehicles',
  sousTitreVide: 'Start by adding your vehicles: everything else depends on them',
  sousTitre: (n: number) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} · each vehicle has its own summer and winter rate`,
  releverKm: 'Record mileage',
  retourService: '← Vehicles in service',
  archivees: 'Archived vehicles',
  ajouter: 'Add a vehicle',
  aucune: 'No vehicles yet',
  ajouterPremiere: 'Add my first vehicle',
  videTexte: 'Each vehicle carries its own rate — a summer rate and a winter rate — and its insurance, road tax and technical inspection dates. The planning board, availability and agreements then fill themselves in from here.',
  demandezGerant: ' Ask a manager to add the vehicles.',
  tarifEte: 'Summer rate',
  tarifHiver: 'Winter rate',
  kilometrage: 'Mileage',
  boite: 'Gearbox',
  boites: { manuelle: 'manual', automatique: 'automatic' },
  toucher: 'Tap to edit ›',
  colonnes: { vehicule: 'Vehicle', immatriculation: 'Registration', categorie: 'Category', km: 'Km', documents: 'Documents', statut: 'Status' },
  aJour: 'up to date',
  remettre: 'Put back in service',
  modifier: 'Edit',
  archiver: 'Archive',
  note: 'The current season’s column is highlighted. A vehicle leaving with expired insurance is the accident that costs the business — hence the alerts at 30, 15 and 7 days.',
  chercherDispo: 'Check availability',
  archiverTitre: (v: string) => `Archive ${v}`,
  archiverBandeauTitre: 'The vehicle leaves day-to-day work',
  archiverBandeau: 'It disappears from the planning board, availability and due dates. Its history — agreements, maintenance, fines — stays available, and you can put it back in service at any time.',
  motif: 'Reason (required)',
  motifAide: 'Sold, damaged, returned to the owner…',
  annuler: 'Cancel',
  modifierTitre: (v: string) => `Edit ${v}`,
  immatriculation: 'Registration',
  immatriculationAide: 'Algerian 6-digit format: 045218-116-16',
  marque: 'Make *',
  modele: 'Model *',
  annee: 'Year',
  categorie: 'Category',
  categories: {
    'A — Citadine': 'A — City car', 'B — Économique': 'B — Economy', 'C — Compacte': 'C — Compact',
    'D — Berline': 'D — Saloon', 'E — SUV': 'E — SUV', 'U — Utilitaire': 'U — Van',
  },
  manuelle: 'Manual',
  automatique: 'Automatic',
  carburant: 'Fuel',
  carburants: { essence: 'petrol', diesel: 'diesel', gpl: 'LPG', hybride: 'hybrid' },
  tarifHaute: (d: string) => `High season rate (${d} / day)`,
  tarifHauteAide: 'Summer.',
  tarifBasse: (d: string) => `Winter rate (${d} / day) *`,
  obligatoire: 'Required.',
  tarifMois: (d: string) => `Monthly rate (${d})`,
  tarifMoisAide: 'Optional — a fixed price per month, whether the month has 28 or 31 days.',
  kmActuel: 'Current mileage',
  tarifSuspect: (prix: string) =>
    `A rate of ${prix} per day is very low: every rental, every payment and the till will be computed `
    + 'from it. If it is negotiated for each rental, enter your usual price here.',
  kmAZero: 'The odometer is at 0: oil changes and return mileage are computed from it. Enter the actual mileage.',
  forfait: (u: string) => `${u} allowance / day`,
  forfaitAide: '0 = unlimited. Clause 05: 250 by default.',
  assuranceExpire: 'Insurance expires on',
  controle: 'Technical inspection',
  vignette: 'Road tax',
  boitier: 'GPS tracker ID',
  boitierAide: 'Fill in the day you equip the fleet. Left empty, it does nothing.',
  enregistrer: 'Save',
  ajouterVoiture: 'Add the vehicle',
};
